import {Tile} from "./tile"
import {Track} from "./track"
import {Cart} from "./cart"

class TileCoordinate {
  x: number
  y: number

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  neighbors() : TileCoordinate[] {
    return [
      new TileCoordinate(this.x + 1, this.y),
      new TileCoordinate(this.x - 1, this.y),
      new TileCoordinate(this.x, this.y + 1),
      new TileCoordinate(this.x, this.y - 1),
    ];
  }

  heuristic(goal: TileCoordinate) {
    let dx = Math.abs(this.x - goal.x)
    let dy = Math.abs(this.y - goal.y)

    return Math.sqrt(dx**2 + dy**2)
  }
}

class World {
  private grid: Tile[][] = [];
  static SIZE = 5;
  cart: Cart;
  mode: "move cart" | "find path" = "move cart";
  trackType: "straight" | "curve"  | "rotatable" = "straight";

  setMode(mode: "move cart" | "find path") {
    this.mode = mode;
  }

  toggleMode() {
    this.mode = this.mode === "move cart" ? "find path" : "move cart";
  }

  constructor(scene) {
    // Initialize world
    for(let x = 0; x < World.SIZE; x++) {
      this.grid[x] = [];
      for(let y = 0; y < World.SIZE; y++) {
        this.grid[x][y] = new Tile(scene, x, y, this);
      }
    }
  }

  getTile(coordinate) {
    if(coordinate.x < 0 || coordinate.x >= World.SIZE || coordinate.y < 0 || coordinate.y >= World.SIZE) {
      throw new Error(`Tile at ${coordinate.x}, ${coordinate.y} does not exist`);
    }
    return this.grid[coordinate.x][coordinate.y]
  }

  getTrack(coordinate) {
    return this.getTile(coordinate).track;
  }
}

export {World, TileCoordinate};